export default "__VITE_ASSET__l74wWg$E__"